// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plainBorder[data-v-c7d27a52]{\n  border-radius: 93.571px;\n  border: 1px solid rgba(210, 214, 220, 1);\n  background: #FFF;\n}\n.customPad[data-v-c7d27a52]{\n  padding: 3.743px 7.486px 3.743px 6px;\n}\n.plainBorder[data-v-c7d27a52]:hover{\n  border: 1px solid var(--Sky-blue, #016BFF);\n}\n", ""]);
// Exports
module.exports = exports;
